(function (global) {
  const PRODUCT_DATA = {
    version: "RM-PRODUCTS-1.0",
    products: [
      {
        id: "pure-gold-no-2-light-roast",
        productId: 6367994118295,
        handle: "pure-gold-no-2-light-roast",
        starterPackOptionLabel: "Light",
        displayName: "Pure Gold No. 2 Light Roast",
        starterPackEligible: true,
        available: true,
        roastLevel: "Light",
        roastIntensity: 1,
        caffeine: "caffeinated",
        flavorTags: { chocolate: 5, caramel: 5, fruit: 5, nuttyToasted: null, brightCitrus: 5, deepRoasted: null },
        sensory: { body: 5, brightness: 4, sweetness: 4, roastCharacter: 1 },
        useFit: { drip: 5, pourOver: 5, frenchPress: 5, espresso: 5, mokaPot: 5, aeropress: 5, reusablePod: 5, coldBrew: 5 },
        drinkingStyleFit: { black: 5, splashMilkCream: 5, milkForward: 5, sweetened: 5, variable: 5 },
        preparation: { wholeBean: true, ground: true },
        evidence: {
          "flavorTags.chocolate": { sourceFact: "Chocolate" },
          "flavorTags.caramel": { sourceFact: "Caramel" },
          "flavorTags.fruit": { sourceFact: "red apple, cherry, fruit flavor" },
          "flavorTags.brightCitrus": { sourceFact: "citrus tones; bright medium acidity" },
          "sensory.body": { sourceFact: "full-bodied; full body" },
          "sensory.brightness": { sourceFact: "bright medium acidity" },
          "sensory.sweetness": { sourceFact: "sweet aroma; honeyed; excellent sweetness" },
          "sensory.roastCharacter": { sourceFact: "Light Roast" }
        }
      },
      {
        id: "pure-gold-no-4-medium-roast",
        productId: 6368007749783,
        handle: "pure-gold-no-4-medium-roast",
        starterPackOptionLabel: "Medium",
        displayName: "Pure Gold No. 4 Medium Roast",
        starterPackEligible: true,
        available: true,
        roastLevel: "Medium",
        roastIntensity: 2,
        caffeine: "caffeinated",
        flavorTags: { chocolate: 5, caramel: null, fruit: 5, nuttyToasted: null, brightCitrus: 4, deepRoasted: null },
        sensory: { body: 5, brightness: 3, sweetness: 4, roastCharacter: 2 },
        useFit: { drip: 5, pourOver: 5, frenchPress: 5, espresso: 5, mokaPot: 5, aeropress: 5, reusablePod: 5, coldBrew: 5 },
        drinkingStyleFit: { black: 5, splashMilkCream: 5, milkForward: 5, sweetened: 5, variable: 5 },
        preparation: { wholeBean: true, ground: true },
        evidence: {
          "flavorTags.chocolate": { sourceFact: "Chocolate" },
          "flavorTags.fruit": { sourceFact: "red apple, cherry, fruit flavor" },
          "flavorTags.brightCitrus": { sourceFact: "citrus tones" },
          "sensory.body": { sourceFact: "full bodied; full body" },
          "sensory.brightness": { sourceFact: "medium acidity" },
          "sensory.sweetness": { sourceFact: "sweet aroma; excellent sweetness" },
          "sensory.roastCharacter": { sourceFact: "Medium Roast" }
        }
      },
      {
        id: "pure-gold-no-6-dark-roast",
        productId: 6368120570007,
        handle: "pure-gold-no-6-dark-roast",
        starterPackOptionLabel: "Dark",
        displayName: "Pure Gold No. 6 Dark Roast",
        starterPackEligible: true,
        available: true,
        roastLevel: "Dark",
        roastIntensity: 4,
        caffeine: "caffeinated",
        flavorTags: { chocolate: 5, caramel: 5, fruit: 3, nuttyToasted: null, brightCitrus: 3, deepRoasted: 5 },
        sensory: { body: 5, brightness: 3, sweetness: 4, roastCharacter: 4 },
        useFit: { drip: 5, pourOver: 5, frenchPress: 5, espresso: 5, mokaPot: 5, aeropress: 5, reusablePod: 5, coldBrew: 5 },
        drinkingStyleFit: { black: 5, splashMilkCream: 5, milkForward: 5, sweetened: 5, variable: 5 },
        preparation: { wholeBean: true, ground: true },
        evidence: {
          "flavorTags.chocolate": { sourceFact: "dark chocolate; chocolate" },
          "flavorTags.caramel": { sourceFact: "creamy caramel" },
          "flavorTags.fruit": { sourceFact: "red apple, cherry, fruit flavor" },
          "flavorTags.brightCitrus": { sourceFact: "citrus tones; medium acidity" },
          "flavorTags.deepRoasted": { sourceFact: "traditional dark roast flavors" },
          "sensory.body": { sourceFact: "full-bodied; full body" },
          "sensory.brightness": { sourceFact: "medium acidity" },
          "sensory.sweetness": { sourceFact: "creamy caramel; excellent sweetness" },
          "sensory.roastCharacter": { sourceFact: "Dark Roast; roasted slightly lighter" }
        }
      },
      {
        id: "pure-gold-melange",
        productId: 7940327178391,
        handle: "pure-gold-melange",
        starterPackOptionLabel: "Mélange",
        displayName: "Pure Gold Melange",
        starterPackEligible: true,
        available: true,
        roastLevel: "Light+Dark Blend",
        roastIntensity: 3.5,
        roastComponents: ["Light Roast", "Dark Roast"],
        caffeine: "caffeinated",
        flavorTags: { chocolate: 5, caramel: null, fruit: 4, nuttyToasted: null, brightCitrus: 4, deepRoasted: 4 },
        sensory: { body: 5, brightness: 4, sweetness: 4, roastCharacter: 4 },
        useFit: { drip: 5, pourOver: 5, frenchPress: 5, espresso: 5, mokaPot: 5, aeropress: 5, reusablePod: 5, coldBrew: 5 },
        drinkingStyleFit: { black: 5, splashMilkCream: 5, milkForward: 5, sweetened: 5, variable: 5 },
        preparation: { wholeBean: true, ground: true },
        evidence: {
          "flavorTags.chocolate": { sourceFact: "Robust chocolate notes from the dark roast component" },
          "flavorTags.fruit": { sourceFact: "red apple, cherry, fruit flavor" },
          "flavorTags.brightCitrus": { sourceFact: "Brightness from the city/light roast component" },
          "flavorTags.deepRoasted": { sourceFact: "Robust chocolate notes from the dark roast component" },
          "sensory.body": { sourceFact: "excellent body; full body" },
          "sensory.brightness": { sourceFact: "Brightness from the city/light roast component" },
          "sensory.sweetness": { sourceFact: "excellent sweetness" },
          "sensory.roastCharacter": { sourceFact: "quite intense and robust but smooth" },
          "useFit.espresso": { sourceFact: "espresso blend; pure espresso" }
        }
      },
      {
        id: "sweet-dreams-decaf",
        productId: 7412484669591,
        handle: "sweet-dreams-decaf",
        starterPackOptionLabel: "Sweet Dreams Decaf",
        displayName: "Sweet Dreams Decaf",
        starterPackEligible: true,
        available: true,
        roastLevel: "Medium",
        roastIntensity: 2,
        caffeine: "decaf",
        flavorTags: { chocolate: 5, caramel: null, fruit: null, nuttyToasted: null, brightCitrus: null, deepRoasted: null },
        sensory: { body: 5, brightness: 0, sweetness: 2, roastCharacter: 2 },
        useFit: { drip: 5, pourOver: 5, frenchPress: 5, espresso: 5, mokaPot: 5, aeropress: 5, reusablePod: 5, coldBrew: 5 },
        drinkingStyleFit: { black: 5, splashMilkCream: 5, milkForward: 5, sweetened: 5, variable: 5 },
        preparation: { wholeBean: true, ground: true },
        evidence: {
          "flavorTags.chocolate": { sourceFact: "Mostly baker's chocolate sensory notes" },
          "sensory.body": { sourceFact: "Full body" },
          "sensory.brightness": { sourceFact: "No acidity whatsoever" },
          "sensory.sweetness": { sourceFact: "Mostly baker's chocolate sensory notes" },
          "sensory.roastCharacter": { sourceFact: "Roast Level: Medium" }
        }
      }
    ]
  };

  const WEIGHTS = { flavor: 0.35, roastIntensity: 0.25, brewMethod: 0.2, drinkingStyle: 0.1, specialPreference: 0.1 };
  const BUSINESS_RULES = {
    allowDuplicateRoasts: false,
    requireDistinctRecommendations: true,
    maxSecondaryScoreDelta: 12,
    decafIsHardFilter: true,
    caffeinatedIsHardFilter: true,
    excludeUnavailable: true,
    excludeNonStarterPack: true,
    explicitDecafAnswer: "decaf",
    explicitCaffeinatedAnswer: "caffeinated",
    merchantExclusions: [],
    productionGate: "APPROVED_FOR_REVIEW"
  };
  const QUESTION_MAP = {
    cup: {
      bright: { label: "Bright, lively and clean", flavor: { brightCitrus: 5, fruit: 4 }, sensory: { brightness: 5, body: 2 }, special: {} },
      balanced: { label: "Balanced, smooth and flavorful", flavor: { chocolate: 3, caramel: 3, fruit: 3 }, sensory: { body: 3, brightness: 3, sweetness: 4 }, special: {} },
      rich: { label: "Rich, chocolate-forward and full-bodied", flavor: { chocolate: 5, caramel: 4 }, sensory: { body: 5, sweetness: 4, roastCharacter: 3 }, special: {} },
      dark: { label: "Bold, dark and intense", flavor: { deepRoasted: 5, chocolate: 4, caramel: 3 }, sensory: { body: 5, roastCharacter: 5 }, special: {} },
      espresso: { label: "I mostly drink espresso", flavor: { chocolate: 3, caramel: 3, deepRoasted: 3 }, sensory: { body: 4, roastCharacter: 3 }, special: { espresso: 5 } },
      surprise: { label: "Surprise me", flavor: {}, sensory: {}, special: {}, neutralizeQ1: true }
    },
    boldness: {
      light: { label: "Light", targetIntensity: 1 },
      medium: { label: "Medium", targetIntensity: 2 },
      medium_dark: { label: "Medium-dark", targetIntensity: 3 },
      dark: { label: "Dark", targetIntensity: 4 },
      max: { label: "As bold as you've got", targetIntensity: 4 }
    },
    flavors: {
      chocolate: { label: "Chocolate", field: "chocolate" },
      caramel: { label: "Caramel", field: "caramel" },
      fruit: { label: "Fruit", field: "fruit" },
      nutty: { label: "Nutty/toasted", field: "nuttyToasted" },
      citrus: { label: "Bright/citrus", field: "brightCitrus" },
      deep: { label: "Deep roasted flavors", field: "deepRoasted" }
    },
    brew: {
      drip: { label: "Automatic drip", field: "drip" },
      pour_over: { label: "Pour-over", field: "pourOver" },
      french_press: { label: "French press", field: "frenchPress" },
      espresso: { label: "Espresso", field: "espresso", special: { espresso: 5 } },
      moka: { label: "Moka pot", field: "mokaPot" },
      aeropress: { label: "AeroPress", field: "aeropress" },
      keurig: { label: "Keurig/reusable pod", field: "reusablePod" },
      cold_brew: { label: "Cold brew", field: "coldBrew" },
      other: { label: "Other", field: null, neutral: true }
    },
    drink: {
      black: { label: "Black", field: "black" },
      cream: { label: "Splash of milk/cream", field: "splashMilkCream" },
      milk: { label: "Milk-forward", field: "milkForward" },
      sweet: { label: "Sweetened", field: "sweetened" },
      depends: { label: "It depends on the day", field: "variable" }
    },
    caffeine: {
      caffeinated: { label: "Regular coffee" },
      decaf: { label: "Decaf only" },
      either: { label: "Either is fine", neutral: true }
    },
    style: {
      "Whole bean": { label: "Whole bean", requires: "wholeBean" },
      Ground: { label: "Ground", requires: "ground" }
    }
  };

  function knownNumber(value) {
    return typeof value === "number" && Number.isFinite(value);
  }

  function scoreKnownMap(actuals, preferences) {
    const entries = Object.entries(preferences || {});
    let earned = 0;
    let possible = 0;
    const reasons = [];

    entries.forEach(([field, preferenceWeight]) => {
      const actual = actuals ? actuals[field] : null;
      if (!knownNumber(actual)) return;
      earned += (actual / 5) * preferenceWeight;
      possible += preferenceWeight;
      reasons.push({ field, actual, preferenceWeight });
    });

    if (!possible) return { score: null, confidence: 0, reasons };
    return { score: (earned / possible) * 100, confidence: possible / Math.max(1, entries.reduce((sum, item) => sum + item[1], 0)), reasons };
  }

  function intensityScore(actual, target) {
    if (!knownNumber(actual) || !knownNumber(target)) return null;
    return Math.max(0, 100 - Math.abs(actual - target) * 25);
  }

  function hardFilters(product, answers, rules) {
    const filters = [];
    if (rules.excludeUnavailable && product.available !== true) filters.push("unavailable");
    if (rules.excludeNonStarterPack && product.starterPackEligible !== true) filters.push("not_starter_pack_eligible");
    if (rules.merchantExclusions.includes(product.id)) filters.push("merchant_exclusion");
    const prep = QUESTION_MAP.style[answers.style || "Whole bean"];
    if (prep && prep.requires && product.preparation && product.preparation[prep.requires] !== true) filters.push(`preparation_unavailable:${prep.requires}`);
    if (answers.caffeine === rules.explicitDecafAnswer && rules.decafIsHardFilter && product.caffeine !== "decaf") filters.push("decaf_required");
    if (answers.caffeine === rules.explicitCaffeinatedAnswer && rules.caffeinatedIsHardFilter && product.caffeine !== "caffeinated") filters.push("caffeinated_required");
    return filters;
  }

  function flavorPreference(answers) {
    const preference = {};
    const cup = QUESTION_MAP.cup[answers.cup] || {};
    Object.entries(cup.flavor || {}).forEach(([field, weight]) => {
      preference[field] = (preference[field] || 0) + weight;
    });
    const selected = Array.isArray(answers.flavors) ? answers.flavors.slice(0, 2) : [];
    selected.forEach((flavor) => {
      const field = QUESTION_MAP.flavors[flavor] && QUESTION_MAP.flavors[flavor].field;
      if (field) preference[field] = (preference[field] || 0) + 5 / Math.max(1, selected.length);
    });
    return preference;
  }

  function confidenceLabel(value) {
    if (value >= 0.75) return "high";
    if (value >= 0.45) return "medium";
    return "low";
  }

  function scoreProduct(product, answers, rules) {
    const filters = hardFilters(product, answers, rules);
    if (filters.length) return { roastId: product.id, eligible: false, totalScore: 0, normalizedScore: 0, confidence: "low", categoryScores: {}, reasons: [], penalties: [], hardFilters: filters };

    const flavorPart = scoreKnownMap(product.flavorTags, flavorPreference(answers));
    const sensoryPart = scoreKnownMap(product.sensory, (QUESTION_MAP.cup[answers.cup] || {}).sensory || {});
    const flavorParts = [flavorPart, sensoryPart].filter((part) => part.score !== null);
    const flavor = flavorParts.length ? flavorParts.reduce((sum, part) => sum + part.score, 0) / flavorParts.length : null;
    const roastIntensity = intensityScore(product.roastIntensity, (QUESTION_MAP.boldness[answers.boldness] || {}).targetIntensity);
    const brewMap = QUESTION_MAP.brew[answers.brew] || {};
    const brewMethod = brewMap.neutral ? null : (brewMap.field ? (knownNumber(product.useFit[brewMap.field]) ? product.useFit[brewMap.field] * 20 : 50) : null);
    const drinkMap = QUESTION_MAP.drink[answers.drink] || {};
    const drinkingStyle = drinkMap.field ? (knownNumber(product.drinkingStyleFit[drinkMap.field]) ? product.drinkingStyleFit[drinkMap.field] * 20 : 50) : null;
    const wantsEspresso = ((QUESTION_MAP.cup[answers.cup] || {}).special || {}).espresso || (brewMap.special || {}).espresso;
    const specialPreference = wantsEspresso ? (knownNumber(product.useFit.espresso) ? product.useFit.espresso * 20 : 50) : null;
    const categoryScores = { flavor, roastIntensity, brewMethod, drinkingStyle, specialPreference };
    let weightedTotal = 0;
    let activeWeight = 0;
    Object.entries(WEIGHTS).forEach(([category, weight]) => {
      if (knownNumber(categoryScores[category])) {
        weightedTotal += categoryScores[category] * weight;
        activeWeight += weight;
      }
    });
    const normalizedScore = activeWeight ? weightedTotal / activeWeight : 0;
    const reasons = buildReasons(product, answers, categoryScores, flavorPart, sensoryPart);
    return {
      roastId: product.id,
      eligible: true,
      totalScore: Number(weightedTotal.toFixed(4)),
      normalizedScore: Number(normalizedScore.toFixed(4)),
      confidence: confidenceLabel(activeWeight),
      confidenceValue: Number(activeWeight.toFixed(4)),
      categoryScores,
      reasons,
      penalties: activeWeight < 0.65 ? ["metadata_sparse"] : [],
      hardFilters: []
    };
  }

  function buildReasons(product, answers, categoryScores, flavorPart, sensoryPart) {
    const reasons = [];
    [flavorPart, sensoryPart].forEach((part) => {
      (part.reasons || []).forEach((reason) => {
        const key = Object.prototype.hasOwnProperty.call(product.flavorTags, reason.field) ? `flavorTags.${reason.field}` : `sensory.${reason.field}`;
        if (product.evidence[key]) reasons.push({ type: "verifiedCharacteristic", field: key, text: product.evidence[key].sourceFact, impact: reason.actual });
      });
    });
    if (knownNumber(categoryScores.roastIntensity)) reasons.push({ type: "intensity", field: "roastIntensity", text: `${product.roastLevel} intensity fit`, impact: categoryScores.roastIntensity });
    if (knownNumber(categoryScores.brewMethod) && QUESTION_MAP.brew[answers.brew] && QUESTION_MAP.brew[answers.brew].field) reasons.push({ type: "brewMethod", field: QUESTION_MAP.brew[answers.brew].field, text: QUESTION_MAP.brew[answers.brew].label, impact: categoryScores.brewMethod });
    if (knownNumber(categoryScores.specialPreference) && product.useFit.espresso === 5) reasons.push({ type: "specialPreference", field: "espresso", text: "Verified espresso positioning", impact: categoryScores.specialPreference });
    return reasons.sort((a, b) => b.impact - a.impact).slice(0, 5);
  }

  function tieBreak(a, b) {
    if (b.normalizedScore !== a.normalizedScore) return b.normalizedScore - a.normalizedScore;
    if ((b.categoryScores.flavor || 0) !== (a.categoryScores.flavor || 0)) return (b.categoryScores.flavor || 0) - (a.categoryScores.flavor || 0);
    if ((b.categoryScores.roastIntensity || 0) !== (a.categoryScores.roastIntensity || 0)) return (b.categoryScores.roastIntensity || 0) - (a.categoryScores.roastIntensity || 0);
    if (b.confidenceValue !== a.confidenceValue) return b.confidenceValue - a.confidenceValue;
    return a.roastId.localeCompare(b.roastId);
  }

  function recommend(answers, options) {
    const rules = Object.assign({}, BUSINESS_RULES, (options && options.businessRules) || {});
    const products = ((options && options.products) || PRODUCT_DATA.products).map((product) => Object.assign({}, product));
    const byId = new Map(products.map((product) => [product.id, product]));
    const ranked = products.map((product) => scoreProduct(product, answers || {}, rules)).sort(tieBreak);
    const primary = ranked.find((result) => result.eligible) || null;
    const secondary = primary ? chooseSecondary(primary, ranked, byId, rules) : { secondary: null, secondaryStrategy: null, explorationDimension: null };
    return {
      scoringVersion: "RM-1.0",
      productDataVersion: PRODUCT_DATA.version,
      quizVersion: "RM-QUIZ-1.0",
      primary,
      secondary: secondary.secondary,
      secondaryStrategy: secondary.secondaryStrategy,
      explorationDimension: secondary.explorationDimension,
      explanationData: primary ? explanationData(primary, secondary.secondary, secondary.secondaryStrategy, secondary.explorationDimension, answers || {}, byId) : null,
      ranked
    };
  }

  function chooseSecondary(primary, ranked, byId, rules) {
    const candidates = ranked.filter((item) => item.eligible && (!rules.requireDistinctRecommendations || item.roastId !== primary.roastId));
    if (!candidates.length) return { secondary: rules.allowDuplicateRoasts ? primary : null, secondaryStrategy: "close-match", explorationDimension: null };
    const pool = candidates.filter((item) => item.normalizedScore >= primary.normalizedScore - rules.maxSecondaryScoreDelta);
    const primaryProduct = byId.get(primary.roastId);
    let best = (pool.length ? pool : candidates)[0];
    let dimension = null;
    let bestContrast = -1;
    (pool.length ? pool : candidates.slice(0, 1)).forEach((item) => {
      const product = byId.get(item.roastId);
      const intensityDelta = knownNumber(product.roastIntensity) && knownNumber(primaryProduct.roastIntensity) ? product.roastIntensity - primaryProduct.roastIntensity : 0;
      const brightnessDelta = knownNumber(product.sensory.brightness) && knownNumber(primaryProduct.sensory.brightness) ? product.sensory.brightness - primaryProduct.sensory.brightness : 0;
      const contrast = Math.abs(intensityDelta) * 2 + Math.abs(brightnessDelta);
      if (contrast > bestContrast || (contrast === bestContrast && tieBreak(item, best) < 0)) {
        best = item;
        bestContrast = contrast;
        dimension = intensityDelta > 0 ? "darker" : intensityDelta < 0 ? "lighter" : brightnessDelta > 0 ? "brighter" : null;
      }
    });
    const strategy = bestContrast >= 2 ? "adjacent-exploration" : "close-match";
    return { secondary: best, secondaryStrategy: strategy, explorationDimension: strategy === "adjacent-exploration" ? dimension : null };
  }

  function explanationData(primary, secondary, strategy, dimension, answers, byId) {
    return {
      primary: explain(primary, answers, byId, "primary"),
      secondary: explain(secondary, answers, byId, "secondary", strategy, dimension)
    };
  }

  function explain(result, answers, byId, slot, strategy, dimension) {
    if (!result) return null;
    const product = byId.get(result.roastId);
    const reasons = result.reasons.slice(0, 3).map((reason) => reason.text);
    const method = QUESTION_MAP.brew[answers.brew] ? QUESTION_MAP.brew[answers.brew].label : "your brew method";
    if (slot === "primary") {
      return {
        heading: "YOUR ROAST MATCH",
        roastName: product.displayName,
        text: `You're looking for ${preferenceSummary(answers)}, and you usually brew with ${method}. ${product.displayName} gives you ${reasons.join(", ")}.`,
        reasons
      };
    }
    const text = strategy === "adjacent-exploration" && dimension
      ? `For your second bag, we're taking you one step ${dimension} so you can compare without jumping too far from what you told us you like.`
      : `We kept your second bag close to the profile you chose, with ${reasons.join(", ")}.`;
    return { heading: "YOUR SECOND BAG", roastName: product.displayName, text, reasons };
  }

  function preferenceSummary(answers) {
    const parts = [];
    if (QUESTION_MAP.cup[answers.cup]) parts.push(QUESTION_MAP.cup[answers.cup].label.toLowerCase());
    if (QUESTION_MAP.boldness[answers.boldness]) parts.push(`${QUESTION_MAP.boldness[answers.boldness].label.toLowerCase()} boldness`);
    const flavors = (answers.flavors || []).map((key) => QUESTION_MAP.flavors[key] && QUESTION_MAP.flavors[key].label.toLowerCase()).filter(Boolean);
    if (flavors.length) parts.push(flavors.join(" and "));
    return parts.slice(0, 3).join(", ") || "a balanced cup";
  }

  global.RoastMatchEngine = {
    recommend,
    products: PRODUCT_DATA.products,
    questionMap: QUESTION_MAP,
    businessRules: BUSINESS_RULES,
    weights: WEIGHTS
  };
})(window);
